var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGemini = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gemini_svg__clip0_6284_42)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#gemini_svg__paint0_radial_6284_42)",
  d: "M32 16.032A17.044 17.044 0 0 0 16.032 32h-.064A17.04 17.04 0 0 0 0 16.032v-.064A17.04 17.04 0 0 0 15.968 0h.064A17.044 17.044 0 0 0 32 15.968z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "gemini_svg__paint0_radial_6284_42",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(32.26518 10.91062 -87.4009 258.46438 3.176 13.006)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.067,
  stopColor: "#9168C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.343,
  stopColor: "#5684D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.672,
  stopColor: "#1BA1E3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "gemini_svg__clip0_6284_42"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGemini);
export default ForwardRef;